module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/beata-pyszkowska-808ea6d50257925357da78779c16abfd.webp";